import { controls } from "../../controls";

const rp455 = {
  label: "Agri Namuna No. 5",
  pageLabel: "Agri Namuna No. 5",
  starting: true,
  url: "rp455",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({ tab: "filter", label: "Taluka", width: "col-sm-2" }),
    ...controls.Taluka({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "taluka_display", name: "taluka_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    ...controls.displayText({ tab: "filter", label: "Product Code", star: true, width: "col-sm-2" }),
    ...controls.product({ tab: "filter" }),
    ...controls.showData({ tab: "filter", isRequired: true, data: "product_code_display", name: "product_code_display", width: "col-sm-2", displaytype: 'camelcase' }),

    ...controls.displayText({ tab: "filter", label: "From Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "from_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "To Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "to_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-3 " }),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter' }),
  ],

  form: [],

  history: {
    perPage: 10,
    reportHeader: "Namuna No.5\nL.T. & M.T. Agri Loan Demand",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Sr",
        type: "autoinc",
        accessor: "srno",
        width: 30
      },
      {
        Header: "Account Name",
        accessor: "descn",
        width: 250,
        rwidth: "*"
      },
      {
        Header: "Outstanding ended 30/06/____",
        accessor: "balance",
        type: "currency",
        width: 130,
        rwidth: 60
      },
      {
        Header: "Overdue ended 30/06/____",
        accessor: "odamt",
        type: "currency",
        width: 130,
        rwidth: 60
      },
      {
        Header: "Recoverable Amount in the Year 201__/__",
        columns: [
          {
            Header: "Date",
            accessor: "recover_date",
            type: "date",
            rwidth: 60
          },
          {
            Header: "Amount",
            accessor: "recover_amount",
            type: "currency",
            rwidth: 60
          }
        ]
      },
      {
        Header: "Total Recoverable Amount in the Year 201__/__",
        accessor: "total_recover_amount",
        type: "currency",
        rwidth: 60
      },
      {
        Header: "Recoverable Amount After 30/06/____",
        columns: [
          {
            Header: "Date",
            accessor: "recover_date",
            type: "date",
            rwidth: 60
          },
          {
            Header: "Amount",
            accessor: "recover_amount",
            type: "currency",
            rwidth: 60
          }
        ]
      },
      {
        Header: "Demand included in the current year, but Loan Disbursement after 30/06/20__ ",
        accessor: "demand_disbur",
        type: "currency",
        rwidth: 60
      }
    ]
  }
};

export default rp455;